<script>
  import { getFeaturedExamples } from "$lib/docs/featured-examples";
  import ExampleCardLinkCarousel from "../ExampleCardLinkCarousel.svelte";

  const examples = getFeaturedExamples("featured");
</script>

<ExampleCardLinkCarousel title="Built with Modal" {examples} />
